export interface Root {
    qrData: Iqrcode
}


export interface Iqrcode {
    type: QrType,
    qrText: string,
    logoSrc: string,
    qrColour: string,
    bgColour: string,
}

export enum QrType {
    TEXT = "text",
    PHONE = "phone",
    EMAIL = "email",
    URL = "url",
    SMS = "sms",
    WIFI = "wifi",
    VCARD = "vcard",
    EVENT = "event",
    BITCOIN = "bitcoin",
    LINK_TREE = "linktree",
    FORM = "form"
}

export enum ColourType {
    QRCOLOUR = "qrColour",
    BGCOLOUR = "bgColour"
}

export interface ChangeColour {
    colourType: ColourType,
    colourValue: string
}